import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 px-6" data-id="element-157">
      <div className="max-w-4xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-gold-500/20 to-transparent border border-gold-500/30 rounded-3xl p-8 md:p-16 text-center relative overflow-hidden" data-id="element-159">
          <div className="absolute top-0 right-0 p-8 opacity-10 pointer-events-none" data-id="element-160">
            <CalendarIcon className="w-48 h-48 text-gold-400" data-id="element-161" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white relative z-10" data-id="element-162">
            ¿Qué cambia en 21 días?
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed relative z-10" data-id="element-163">
            En tres semanas habrás configurado tu escudo de crédito, habrás
            recuperado al menos el 15% de tu sueldo que antes se iba en gastos
            invisibles y, por primera vez,{' '}
            <strong className="text-gold-400 font-normal" data-id="element-164">
              sabrás exactamente a dónde va cada dólar de tu cheque.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}